export enum SidenavItemEnum {

  PaginaInicial = 'Página Inicial',
  SelecionaEntidade = 'Selecionar Entidade',
  SelecionaInstituicao = 'Selecionar Instituição',
  Rda = 'RDA',
  DadosGerais = 'Dados Gerais da Empresa',
  IdentificacaoEmpresa = 'Identificação da Empresa',
  DeclaracaoRda = 'Declaração RDA',
  FaturamentoProduto = 'Fat. Produto - 5.906/2006',
  FaturamentoProdutoLei10356 = 'Fat. Produto - 10.356/2020',
  FaturamentoBruto = 'Faturamento Bruto',
  ProjetoProprio = 'Projeto Próprio',
  ProjetoConveniado = 'Projeto Conveniado',
  NotificacaoInstituicao = 'Projeto Conveniado - NI',
  Auditoria = 'Auditoria',
  AnexarDocumentoRda = 'Anexar Documento RDA',
  ObrigacaoAplicacao = 'Obrigações e Aplicações',
  VisualizarRda = 'Visualizar RDA',
  AnexarRelatorioConclusivo = 'Anexar Relatório Conclusivo',
  ConfigurarParametro = 'Configurar Parâmetro',
  CartaCredito = 'Gerar Certificado de Crédito',
  VincularContrante = 'Vincular Contratante',
  RetificarCartaCredito = 'Retificar Certificado de Crédito',
  FiscalizacaoElaborarParecer = 'Elaborar Parecer',
  GerirEntidade = 'Gerir Entidade',
  GerirPleito = 'Gerir Pleito',
  GerirPleitoMCTI = 'Gerir Pleito MCTI',
  Pleitos = 'Pleitos',
  PleitoHabilitacao = 'Pleito Habilitação',
  GerirStatus = 'Gerir Status'
}

export const menusFiscalizacao: string[] = [
  SidenavItemEnum.PaginaInicial,
  SidenavItemEnum.FiscalizacaoElaborarParecer
];

export const menusRda: string[] = [
  SidenavItemEnum.PaginaInicial,
  SidenavItemEnum.SelecionaEntidade,
  SidenavItemEnum.SelecionaInstituicao,
  SidenavItemEnum.Rda,
  SidenavItemEnum.DadosGerais,
  SidenavItemEnum.IdentificacaoEmpresa,
  SidenavItemEnum.DeclaracaoRda,
  SidenavItemEnum.FaturamentoProduto,
  SidenavItemEnum.FaturamentoProdutoLei10356,
  SidenavItemEnum.FaturamentoBruto,
  SidenavItemEnum.ProjetoProprio,
  SidenavItemEnum.ProjetoConveniado,
  SidenavItemEnum.NotificacaoInstituicao,
  SidenavItemEnum.Auditoria,
  SidenavItemEnum.AnexarDocumentoRda,
  SidenavItemEnum.ObrigacaoAplicacao,
  SidenavItemEnum.VisualizarRda,
  SidenavItemEnum.AnexarRelatorioConclusivo,
  SidenavItemEnum.CartaCredito,
  SidenavItemEnum.VincularContrante,
  SidenavItemEnum.RetificarCartaCredito,
  SidenavItemEnum.ConfigurarParametro,
];

export const menusGerenciamento: string[] = [
  SidenavItemEnum.PaginaInicial,
  SidenavItemEnum.GerirPleito,
  SidenavItemEnum.GerirEntidade,
  SidenavItemEnum.GerirPleitoMCTI,
  SidenavItemEnum.Pleitos,
  SidenavItemEnum.PleitoHabilitacao,
  SidenavItemEnum.GerirStatus,
];

export const menusInicial: string[] = [
  SidenavItemEnum.PaginaInicial
];
